import EZO	from "./circuits/ezo.js";
import sleep from "sleep";

class PHSensor extends EZO {
  constructor(p) {
    super(0x63);

    this.id = "";
    this.status = "uninitialized";
  }
  async initialize() {
    try {
      await super.initialize();
      this.id = await this.command("i");
      this.calibrationStatus = await this.command("Cal,?");
      this.slope = await this.command("Slope,?");
      this.internalTemperature = "N/A";
      /* await this.command(`T,25`); */
      this.status = "ok";
    } catch(e) {
      this.status = "failed";
      throw e;
    }
  }
  async update(devices) {
    /* 
      from firmware version 2.12 we can use the RT command:
      RT,n set temperature compensation and take a reading

      //await this.command(`T,${devices.temperatureSensor.value?devices.temperatureSensor.value:25}`);
      //this.value = await this.command("R");
    */
    
    var T;
    if (devices.temperatureSensor)
      T = devices.temperatureSensor.value;
    if (devices.ezortdSensor)
      T = devices.ezortdSensor.value;
        
    this.value = parseFloat( await this.command(`RT,${T?T:25}`) );
  }
  async clearCalibration() {
    await this.command("Cal,clear");
    this.calibrationStatus = await this.command("Cal,?");
    this.slope = await this.command("Slope,?");          
  }
  async calibrateTo4() {
    await this.command("Cal,low,4.00");
    this.calibrationStatus = await this.command("Cal,?");
    this.slope = await this.command("Slope,?");              
  }
  async calibrateTo7() {
    await this.command("Cal,mid,7.00");
    this.calibrationStatus = await this.command("Cal,?");
    this.slope = await this.command("Slope,?");              
  }
  async calibrateTo10() {
    await this.command("Cal,high,10.00");
    this.calibrationStatus = await this.command("Cal,?");
    this.slope = await this.command("Slope,?");              
  }
  toJSON() {
    return({
      id: this.id,
      status: this.status,
      value: this.value,
      calibrationStatus: this.calibrationStatus,
      slope: this.slope,
      internalTemperature: this.internalTemperature
    });
  }
}

export default PHSensor;